const usePermissionConfig = () => {
  return {
    /*
    * 新增域名配置
    * 控制：新增域名配置
    * 跳转路由名称：
    * */
    CREATE: 'OPS-XTPZ-YMPZ-XZYMPZ',
    /*
    * 编辑
    * 控制：编辑
    * 跳转路由名称：
    * */
    UPDATE: 'OPS-XTPZ-YMPZ-BJ',
    /*
    * 删除
    * 控制：删除
    * 跳转路由名称：
    * */
    DELETE: 'OPS-XTPZ-YMPZ-SC',
  };
};

export default usePermissionConfig;
